import { addToast } from "@heroui/react";

/**
 * アプリ共通の通知ヘルパ。
 *
 * ngtg_msc の AppSnackBar に対応する。成功／エラーで配色を統一し、
 * `addToast` を直接呼ばずここを経由させることで見た目を揃える。
 */

/** 成功メッセージ（ブランドカラー）。 */
export function showSuccess(message: string): void {
  addToast({ description: message, color: "primary", timeout: 3000 });
}

/**
 * お知らせ（中立）。
 *
 * 失敗ではないが伝えたいこと（未実装の機能を押したときなど）に使う。
 * これを showError で出すと、何か壊れたように見えてしまう。
 */
export function showInfo(message: string): void {
  addToast({ description: message, color: "default", timeout: 4000 });
}

/** エラーメッセージ（danger）。 */
export function showError(message: string): void {
  addToast({ description: message, color: "danger", timeout: 5000 });
}
